<app-header>
   <jbm-view-title [caption]="'menu.invoicing'|translate" [iconClassname]="'calculator'"
      subCaption="{{'invoice.invoiceable'|translate}} {{'menu.production'|translate|lowercase}}{{'production.receipts'|translate|lowercase}}"
      [parentLinkCaption]="'menu.invoicing'|translate" [parentLinkSlug]="'invoicing'" [itemcount]="itemCount">
   </jbm-view-title>
   <div class="toolbar ml-4 float-start">
      <label *ngIf="plantOptions.length">{{'company.plant'|translate}}</label>
      <select *ngIf="plantOptions.length" (change)="changePlant($event)" [value]="plants_id"
         class="form-control form-control-sm form-select">
         <option *ngFor="let plant of plantOptions" value="{{plant.key}}">
            {{plant.value}}
         </option>
      </select>
   </div>
   <div class="toolbar float-end">
      <jbm-spinner [loading]="loading"></jbm-spinner>
      <div class="toolbar-spacer-1"></div>
      <jbm-pagination [hidden]="!initialCount" [itemCount]="queryHttpHelper.paginationProps.itemCount"
         [pageSize]="queryHttpHelper.paginationProps.pageSize" [page]="queryHttpHelper.paginationProps.page"
         (pageClick)="pageChange($event)">
      </jbm-pagination>
      <div [hidden]="!initialCount" class="toolbar-spacer-1 float-end"></div>
      <div [hidden]="!initialCount" class="btn-group float-end">
         <jbm-filter-toggle [showFilter]="filtersVisible" (onToggle)="toggleFilters($event)"></jbm-filter-toggle>
         <jbm-filter-reset [disabled]="!queryHttpHelper.hasAndFilters() && !plants_id && !projects_id" (onReset)="resetFilters()"></jbm-filter-reset>
         <jbm-table-layout [caption]="'ui.columns-layout'|translate" [columnDefs]="columnDefs"
            (columnToggled)="saveLayout($event)"></jbm-table-layout>
      </div>
      <div class="toolbar-spacer-1"></div>
      <jbm-help-button [helpTopicID]="0"></jbm-help-button>
   </div>
</app-header>
<section class="module invoiceable-receipts">
   <div class="bg-blue-extra-light p-2 pl-3 pr-3 clearfix">
      <div class="float-start">
         <label class="col-form-label-sm float-start mr-2">{{'invoice.date'|translate}}:</label>
         <div class="float-start">
            <input class="form-control form-control-sm delivery-date" [maxLength]="10"
               [placeholder]="'datetime.date-format'|translate" [placement]="'bottom'" [container]="'body'" name="dp"
               [(ngModel)]="date" ngbDatepicker #d="ngbDatepicker" (change)="onChangeDate()" (blur)="onChangeDate()"
               [ngClass]="{'ng-valid':validateDate(), 'is-invalid':this.dateTouched && !validateDate()}">
         </div>
         <div class="float-start">
            <button type="button" class="btn btn-sm btn-light" (click)="d.toggle()">
               <i class="fa fa-calendar"></i>
            </button>
         </div>
      </div>
      <div *ngIf="projects_id" class="float-start">
       <label class="col-form-label-sm float-start ms-4 mr-2">{{'entity.project'|translate}}:</label>
       <button *ngIf="projects_id" class="btn btn-sm btn-link text-left float-start pl-0"
           [ngbTooltip]="('entity.project'|translate)+' '+('ui.details'|translate|lowercase)"
           (click)="showProject(projects_id);$event.stopPropagation();">
           <jbm-label-with-ID [IDPosition]="userPreferences.display.IDdisplay" [ID]="projects_id" [label]="project_name"></jbm-label-with-ID>
       </button>
       <span class="badge bg-secondary text-white ms-2 me-2">
         {{receipt_ids.length}}&nbsp;
         {{'menu.production'|translate|lowercase}}
         <span *ngIf="receipt_ids.length==1">{{'production.receipt'|translate|lowercase}}</span>
         <span *ngIf="receipt_ids.length>1">{{'production.receipts'|translate|lowercase}}</span>
       </span>
       <button *ngIf="receipt_ids.length>0" type="button" class="btn btn-sm btn-light ml-2" (click)="resetSelection()">{{'ui.unselect'|translate}}</button>
      </div>
      <button type="button" class="btn btn-sm btn-success float-start ml-4" [disabled]="receipt_ids.length===0"
         (click)="generateReceiptsInvoice()">{{'entity.invoice'|translate}} {{'ui.generate'|translate|lowercase}}
      </button>
   </div>
   <jbm-table #table [id]="'invoiceable-receipts'" [absolute]="true" [classname]="'padding'" [data]="receipts" [filterable]="true"
      [fullWidth]="false" [showFilters]="filtersVisible" [searchMinLength]="3" [sortable]="true"
      [sortColumn]="queryHttpHelper.sortProps.name" [sortDirection]="queryHttpHelper.sortProps.direction"
      [hoverable]="true" [rowSelectable]="false" [columnDefs]="columnDefs" [stringIDdisplay]="userPreferences.display.IDdisplay"
      (sortChange)="sortChange($event)" (filterChange)="filterChange($event)"
      (columnDefsChange)="saveLayout($event)" (rowCountChange)="rowCountChange($event)">
   </jbm-table>
   <jbm-empty-view [emptyView]="!loading && itemCount==0"></jbm-empty-view>
</section>
<jbm-toasts></jbm-toasts>

<ng-template #templateCheck let-data="data">
  <input *ngIf="!data.production_cancelled && !data.dropped && data.delivery!==deliveryState.partly" type="checkbox" class="form-check-input mt-1" (click)="$event.stopPropagation()"
      (change)="toggleReceipt(data); $event.stopPropagation()" [checked]="receipt_ids.indexOf(data.id) > -1">
</ng-template>

<ng-template #templateCustomer let-data="data">
   <button *ngIf="data.customer_id" class="btn btn-sm btn-link text-left float-start pl-0"
      [ngbTooltip]="('entity.customer'|translate)+' '+('ui.details'|translate|lowercase)"
      (click)="showCustomer(data.customer_id);$event.stopPropagation();">
      <jbm-label-with-ID [IDPosition]="userPreferences.display.IDdisplay" [ID]="data.customer_id" [label]="data.customer"></jbm-label-with-ID>
   </button>
   <span *ngIf="data.customer_id && data.blocked" class="pl-0 pt-1 blocked float-start">
      <span [ngbTooltip]="'entity.blocked'|translate" class="text-danger"><i class="fa fa-exclamation-triangle"></i></span>
   </span>
</ng-template>

<ng-template #templateProject let-data="data">
   <button *ngIf="data.project_id" class="btn btn-sm btn-link text-left float-start pl-0"
      [ngbTooltip]="('entity.project'|translate)+' '+('ui.details'|translate|lowercase)"
      (click)="showProject(data.project_id);$event.stopPropagation();">
      <jbm-label-with-ID [IDPosition]="userPreferences.display.IDdisplay" [ID]="data.project_id" [label]="data.project"></jbm-label-with-ID>
   </button>
</ng-template>

<ng-template #templateOrder let-data="data">
   <button *ngIf="data.orders_id" class="btn btn-sm btn-link text-left float-start pl-0"
      [ngbTooltip]="('project.order'|translate)+' '+('ui.details'|translate|lowercase)"
      (click)="showOrder(data.orders_id);$event.stopPropagation();">
      <jbm-label-with-ID [IDPosition]="userPreferences.display.IDdisplay" [ID]="data.orders_id" [label]="data.order_description"></jbm-label-with-ID>
   </button>
</ng-template>

<ng-template #templateRecipe let-data="data">
   <button class="btn btn-sm btn-link text-left float-start pl-0"
      [ngbTooltip]="('entity.recipe'|translate)+' '+('ui.details'|translate|lowercase)"
      (click)="showRecipe(data.plants_id, data.recipes_id, data.execute_date, data.environment); $event.stopPropagation();">
      <jbm-label-with-ID [IDPosition]="userPreferences.display.IDdisplay" [ID]="data.public_id" [label]="data.recipe"></jbm-label-with-ID>
   </button>
</ng-template>

<ng-template #templateDelivery let-data="data">
   <span *ngIf="data.delivery===deliveryState.complete" class="badge bg-success w-100">{{'ui.complete'|translate}}</span>
   <span *ngIf="data.delivery===deliveryState.partly" class="badge bg-warning w-100">{{'ui.partly'|translate}} {{'order.delivered'|translate|lowercase}}</span>
   <span *ngIf="data.delivery===deliveryState.dropped" class="badge bg-danger w-100" [ngbTooltip]="data.dropped_reason">{{'ui.dropped'|translate}}&nbsp;&nbsp;<i class="fa fa-info"></i></span>
   <span *ngIf="data.delivery===deliveryState.none" class="badge bg-danger w-100">{{'ui.not'|translate}} {{'order.delivered'|translate|lowercase}}</span>
   <span *ngIf="data.delivery===deliveryState.productionCancelled" class="badge bg-danger w-100">{{'ui.not'|translate}} {{'production.produced'|translate|lowercase}}</span>
</ng-template>

<jbm-modal [id]="'projectDetails'" [className]="'project-details'"></jbm-modal>
<ng-template #modalProjectDetails let-modal>
   <project-details [project_id]="modal_projects_id" (onClose)="closeProject()"></project-details>
</ng-template>

<jbm-modal [id]="'customerDetails'" [className]="'customer-details'"></jbm-modal>
<ng-template #modalCustomerDetails let-modal>
   <customer-details [customer]="customer" [inModal]="true" (onClose)="closeCustomer()"></customer-details>
</ng-template>

<jbm-modal [id]="'recipe'" [className]="'invoice-recipe'"></jbm-modal>
<ng-template #modalRecipe let-modal>
   <recipe-details [delivery_date]="delivery_date" [plant_id]="plant_id" [recipe_id]="recipe_id"
      [environment]="environment" (onClose)="closeRecipe()"></recipe-details>
</ng-template>

<jbm-modal [id]="'order'" [className]="'order-details'"></jbm-modal>
<ng-template #modalOrder let-modal>
   <order-details [order_id]="order_id" (onClose)="closeOrder()"></order-details>
</ng-template>
